export const menus = {
  pages: [
    {
      name: "Home",
      slug: "",
      layout: "",
    },
    {
      id: 1,
      name: "Traffic School Program",
      slug: "traffic-school-program",
      type: "page",
      open_url: "new_tap",
      sort: 2,
      sub_page: "0",
      layout: 2,
      external_url: null,
      sub_menu: [
        {
          id: 10,
          name: "All Courses",
          slug: "traffic-school-program",
          type: "page",
          open_url: "same_page",
          sort: 1,
          layout: 2,
          sub_page: "1",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 11,
          name: "Online Courses",
          slug: "online-traffic-school",
          type: "page",
          open_url: "same_page",
          sort: 2,
          layout: 2,
          sub_page: "1",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 12,
          name: "Classroom Course",
          slug: "classroom-traffic-school",
          type: "page",
          open_url: "same_page",
          sort: 3,
          layout: 2,
          sub_page: "1",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 14,
          name: "First Time Driver",
          slug: "first-time-driver",
          type: "page",
          open_url: "same_page",
          sort: 5,
          layout: 2,
          sub_page: "1",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 15,
          name: "Mature Driver Course",
          slug: "mature-driver-course",
          type: "page",
          open_url: "same_page",
          sort: 6,
          layout: 2,
          sub_page: "1",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 16,
          name: "Victim Impact & Awareness Program",
          slug: "victim-impact",
          type: "page",
          open_url: "same_page",
          sort: 7,
          layout: 2,
          sub_page: "1",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
      ],
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 2,
      name: "DUI School",
      slug: "dui-school",
      type: "page",
      open_url: "new_tap",
      sort: 3,
      sub_page: "0",
      layout: 1,
      external_url: null,
      sub_menu: [],
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 3,
      name: "Workplace Safety",
      slug: null,
      type: "url",
      open_url: "new_tap",
      sort: 4,
      sub_page: "0",
      layout: 1,
      external_url: "https://www.metrofloridasafetycouncil.com",
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 4,
      name: "Driving Lessons",
      slug: "driving-lessons",
      type: "page",
      open_url: null,
      sort: 5,
      sub_page: "0",
      layout: 1,
      external_url: null,
      sub_menu: [
        {
          id: 18,
          name: "Central Florida",
          slug: "#",
          type: "page",
          open_url: "same_page",
          sort: 1,
          layout: 0,
          sub_page: "4",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
          sub_menu: [
            {
              id: 101,
              name: "Orange County Driving Lessons",
              slug: "orange-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 1,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
            {
              id: 102,
              name: "Seminole County Driving Lessons",
              slug: "seminole-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 2,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
            {
              id: 103,
              name: "Osceola County Driving Lessons",
              slug: "osceola-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 3,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
            {
              id: 104,
              name: "Lake County Driving Lessons",
              slug: "lake-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 4,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
            {
              id: 105,
              name: "Volusia County Driving Lessons",
              slug: "volusia-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 5,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
          ],
        },
        {
          id: 19,
          name: "South Florida",
          slug: "#",
          type: "page",
          open_url: "same_page",
          sort: 2,
          layout: 0,
          sub_page: "4",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
          sub_menu: [
            {
              id: 106,
              name: "Miami-Dade Driving Lessons",
              slug: "miami-dade-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 1,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
            {
              id: 107,
              name: "Broward Driving Lessons",
              slug: "broward-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 2,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
            {
              id: 108,
              name: "Palm Beach Driving Lessons",
              slug: "palm-beach-county-driving-lessons",
              type: "page",
              open_url: "same_page",
              sort: 3,
              layout: 0,
              sub_page: "4",
              external_url: "",
              cover_image_url: null,
              banner_image_url: null,
            },
          ],
        },

      ],
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 5,
      name: "DMV Testing",
      slug: "florida-driving-test",
      type: "page",
      open_url: null,
      sort: 6,
      sub_page: "0",
      layout: 1,
      external_url: null,
      sub_menu: [
        {
          id: 20,
          name: "Driver License Road Test",
          slug: "driver-license-road-test",
          type: "page",
          open_url: "same_page",
          sort: 1,
          layout: 0,
          sub_page: "5",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 21,
          name: "Drug and Alcohol Course Packages",
          slug: "first-time-driver",
          type: "page",
          open_url: "same_page",
          sort: 2,
          layout: 0,
          sub_page: "5",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 22,
          name: "Driver Test Online",
          slug: "florida-driving-test",
          type: "page",
          open_url: "same_page",
          sort: 3,
          layout: 0,
          sub_page: "5",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 23,
          name: "Driver Test In Person",
          slug: "dmv-test-in-person",
          type: "page",
          open_url: "same_page",
          sort: 4,
          layout: 0,
          sub_page: "5",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 24,
          name: "Florida's Driver's Handbook",
          slug: "florida-driver-handbook",
          type: "page",
          open_url: "same_page",
          sort: 5,
          layout: 0,
          sub_page: "5",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
      ],
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 6,
      name: "Contact Us",
      slug: "locations",
      type: "page",
      open_url: null,
      sort: 7,
      sub_page: "0",
      layout: 1,
      external_url: null,
      sub_menu: [
        {
          id: 25,
          name: "Contact Form",
          slug: "contact-us",
          type: "page",
          open_url: "same_page",
          sort: 1,
          layout: 0,
          sub_page: "6",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 26,
          name: "Locations",
          slug: "locations",
          type: "page",
          open_url: "same_page",
          sort: 2,
          layout: 0,
          sub_page: "6",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 27,
          name: "Reviews",
          slug: "reviews",
          type: "page",
          open_url: "same_page",
          sort: 3,
          layout: 0,
          sub_page: "6",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
      ],
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 7,
      name: "Español",
      slug: "cursos-en-espanol",
      type: "page",
      open_url: null,
      sort: 8,
      sub_page: "0",
      layout: 1,
      external_url: null,
      sub_menu: [
        {
          id: 29,
          name: "Curso de Educación Vial para Conductores (DETS)",
          slug: "dets-curso",
          type: "page",
          open_url: "same_page",
          sort: 1,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 30,
          name: "Todos los cursos en Español",
          slug: "cursos-en-espanol",
          type: "page",
          open_url: "same_page",
          sort: 2,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 31,
          name: "Curso para citaciones de tráfico",
          slug: "curso-para-multas",
          type: "page",
          open_url: "same_page",
          sort: 3,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 32,
          name: "Curso para obtener la licencia",
          slug: "curso-para-obtener-la-licencia",
          type: "page",
          open_url: "same_page",
          sort: 4,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 33,
          name: "Clases de manejo",
          slug: "clases-de-manejo",
          type: "page",
          open_url: "same_page",
          sort: 5,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 34,
          name: "Curso de DUI en Espanol",
          slug: "dui-en-espanol",
          type: "page",
          open_url: "same_page",
          sort: 6,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 35,
          name: "Examen Práctico de Licencia de Conducir",
          slug: "examen-practico-de-licencia-de-conducir",
          type: "page",
          open_url: "same_page",
          sort: 7,
          layout: 0,
          sub_page: "7",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
      ],
      cover_image_url: null,
      banner_image_url: null,
    },
    {
      id: 8,
      name: "Online Courses",
      slug: "online-traffic-school",
      type: "page",
      open_url: "online-traffic-school",
      sort: 9,
      sub_page: "0",
      layout: 1,
      external_url: null,
      sub_menu: [
        {
          id: 36,
          name: "Driver Education Traffic Safety (DETS)",
          slug: "dets-course",
          type: "page",
          open_url: "same_page",
          sort: 1,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 37,
          name: "4 Hour BDI",
          slug: "4-hour-bdi-online",
          type: "page",
          open_url: "same_page",
          sort: 2,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 38,
          name: "Mature Driver Course",
          slug: "mature-driver-course",
          type: "page",
          open_url: "same_page",
          sort: 3,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 39,
          name: "8 Hour IDI",
          slug: "8-hour-idi-course",
          type: "page",
          open_url: "same_page",
          sort: 4,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 40,
          name: "First Time Driver",
          slug: "first-time-driver",
          type: "page",
          open_url: "same_page",
          sort: 5,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        // {
        //   id: 41,
        //   name: "Drug and Alcohol Course",
        //   slug: "first-time-driver-course",
        //   type: "page",
        //   open_url: "same_page",
        //   sort: 5,
        //   layout: 0,
        //   sub_page: "8",
        //   external_url: "",
        //   cover_image_url: null,
        //   banner_image_url: null,
        // },
        {
          id: 42,
          name: "12 Hour ADI",
          slug: "12-hour-adi",
          type: "page",
          open_url: "same_page",
          sort: 6,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 43,
          name: "Curso para citaciones de tráfico",
          slug: "curso-para-multas",
          type: "page",
          open_url: "same_page",
          sort: 7,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
        {
          id: 44,
          name: "Curso para obtener la licencia",
          slug: "curso-para-obtener-la-licencia",
          type: "page",
          open_url: "same_page",
          sort: 8,
          layout: 0,
          sub_page: "8",
          external_url: "",
          cover_image_url: null,
          banner_image_url: null,
        },
      ],
      cover_image_url: null,
      banner_image_url: null,
    },
    // {
    //     "id": 1,
    //     "name": "New Drivers",
    //     "slug": "new-drivers",
    //     "type": "page",
    //     "open_url": "new_tap",
    //     "sort": 1,
    //     "sub_page": "0",
    //     "layout": 2,
    //     "external_url": null,
    //     "sub_menu": [
    //         {
    //             "id": 5,
    //             "name": "Drug & Alcohol Course",
    //             "slug": "new-drivers",
    //             "type": "page",
    //             "open_url": "same_page",
    //             "sort": 1,
    //             "layout": 2,
    //             "sub_page": "1",
    //             "external_url": "",
    //             "cover_image_url": null,
    //             "banner_image_url": null
    //         },
    //         {
    //             "id": 6,
    //             "name": "DMV Testing",
    //             "slug": "new-drivers",
    //             "type": "page",
    //             "open_url": "same_page",
    //             "sort": 2,
    //             "layout": 2,
    //             "sub_page": "1",
    //             "external_url": null,
    //             "cover_image_url": null,
    //             "banner_image_url": null
    //         },
    //         {
    //             "id": 7,
    //             "name": "Driving Lessons",
    //             "slug": "new-drivers/driving-lessons",
    //             "type": "page",
    //             "open_url": null,
    //             "sort": 3,
    //             "layout": 2,
    //             "sub_page": "1",
    //             "external_url": null,
    //             "cover_image_url": null,
    //             "banner_image_url": null
    //         },
    //         {
    //             "id": 8,
    //             "name": "Leaners Permit",
    //             "slug": "new-drivers",
    //             "type": "page",
    //             "open_url": "same_page",
    //             "sort": 4,
    //             "layout": 2,
    //             "sub_page": "1",
    //             "external_url": "",
    //             "cover_image_url": null,
    //             "banner_image_url": null
    //         },
    //         {
    //             "id": 9,
    //             "name": "DMV Locations",
    //             "slug": null,
    //             "type": "url",
    //             "open_url": "new_tap",
    //             "sort": 5,
    //             "layout": 2,
    //             "sub_page": "1",
    //             "external_url": "https://www.flhsmv.gov/locations/",
    //             "cover_image_url": null,
    //             "banner_image_url": null
    //         }
    //     ],
    //     "cover_image_url": null,
    //     "banner_image_url": null
    // },
    // {
    //   id: 2,
    //   name: "Tickets  &  Violations",
    //   slug: "tickets-violations/traffic-school",
    //   type: "page",
    //   open_url: null,
    //   sort: 2,
    //   sub_page: "0",
    //   layout: 1,
    //   external_url: null,
    //   sub_menu: [
    //     {
    //       id: 10,
    //       name: "4-Hour Basic Driver Improvement",
    //       slug: "tickets-violations/4-hour-basic-driver-improvement",
    //       type: "page",
    //       open_url: null,
    //       sort: 1,
    //       layout: 3,
    //       sub_page: "2",
    //       external_url: null,
    //       cover_image_url: null,
    //       banner_image_url: null,
    //     },
    //     {
    //       id: 11,
    //       name: "8-Hour Intermediate Driver Improvement",
    //       slug: "tickets-violations/8-hour-intermediate-driver-improvement",
    //       type: "page",
    //       open_url: null,
    //       sort: 2,
    //       layout: 3,
    //       sub_page: "2",
    //       external_url: null,
    //       cover_image_url: null,
    //       banner_image_url: null,
    //     },
    //     {
    //       id: 12,
    //       name: "12-Hour Advanced Driver Improvement",
    //       slug: "tickets-violations/12-hour-advanced-driver-improvement",
    //       type: "page",
    //       open_url: null,
    //       sort: 3,
    //       layout: 3,
    //       sub_page: "2",
    //       external_url: null,
    //       cover_image_url: null,
    //       banner_image_url: null,
    //     },
    //     {
    //       id: 13,
    //       name: "Traffic School",
    //       slug: "tickets-violations/traffic-school",
    //       type: "page",
    //       open_url: null,
    //       sort: 4,
    //       layout: 1,
    //       sub_page: "2",
    //       external_url: null,
    //       cover_image_url: null,
    //       banner_image_url: null,
    //     },
    //     {
    //       id: 14,
    //       name: "Clerk of Court",
    //       slug: "",
    //       type: "url",
    //       open_url: "new_tap",
    //       sort: 5,
    //       layout: 2,
    //       sub_page: "2",
    //       external_url: "https://www.flclerks.com/page/FindaClerk",
    //       cover_image_url: null,
    //       banner_image_url: null,
    //     },
    //   ],
    //   cover_image_url: null,
    //   banner_image_url: null,
    // },
    // {
    //   id: 3,
    //   name: "DUI School",
    //   slug: "dui-school",
    //   type: "page",
    //   open_url: "new_tap",
    //   sort: 3,
    //   sub_page: "0",
    //   layout: 1,
    //   external_url: null,
    //   sub_menu: [],
    //   cover_image_url: null,
    //   banner_image_url: null,
    // },
    // {
    //   id: 4,
    //   name: "Other Programs",
    //   slug: "#",
    //   type: "page",
    //   open_url: null,
    //   sort: 4,
    //   sub_page: "0",
    //   layout: 1,
    //   external_url: null,
    //   sub_menu: [
    //     {
    //       id: 15,
    //       name: "Workplace Safety",
    //       slug: "",
    //       type: "url",
    //       open_url: "new_tap",
    //       sort: 1,
    //       layout: 0,
    //       sub_page: "4",
    //       external_url: "https://metrofloridasafetycouncil.com/",
    //       cover_image_url: null,
    //       banner_image_url: null,
    //     },
    //   ],
    //   cover_image_url: null,
    //   banner_image_url: null,
    // },
    // {
    //   name: "FAQ",
    //   slug: "faq",
    //   layout: "",
    // },
    // {
    //   id: 14,
    //   name: "Clerk of Court",
    //   slug: "",
    //   type: "url",
    //   open_url: "new_tap",
    //   sort: 5,
    //   sub_page: "2",
    //   layout: 2,
    //   external_url: "https://www.flclerks.com/page/FindaClerk",
    //   cover_image_url: null,
    //   banner_image_url: null,
    // },
    // {
    //   name: "Contact Us",
    //   slug: "contact-us",
    //   layout: "",
    //   active_identity: "contact-us",
    //   sub_menu: [
    //     {
    //       name: "Locations",
    //       slug: "#",
    //       layout: "0",
    //       sub_menu: [
    //         {
    //           name: "Miami Dade County",
    //           slug: "miami-dade",
    //           layout: "0",
    //         },
    //         {
    //           name: "Broward County",
    //           slug: "broward-county",
    //           layout: "0",
    //         },
    //         {
    //           name: "Palm Beach County",
    //           slug: "palmbeach-county",
    //           layout: "0",
    //         },
    //         {
    //           name: "Central Florida",
    //           slug: "central-florida",
    //           layout: "0",
    //         },
    //       ],
    //     },
    //     {
    //       name: "Customer Support",
    //       slug: "customer-support",
    //       layout: "0",
    //     },
    //   ],
    // },
  ],
  settings: {
    general: {
      site_phone: "(305) 513-0063",
      site_phone_2: "1-888-41-METRO",
      site_email: "info@metrotrafficschool.com",
      home_page_content:
        "<p>Metro Traffic School is approved by the State of Florida and the Department of Highway Safety &amp; Motor Vehicles to offer a variety of programs, such as the 4-Hour New Driver (Drug and Alcohol course), DMV Permit Test, Behind the Wheel Training (Driving Lessons), Traffic School courses for traffic tickets and suspended driver’s licenses, and lastly Driving Under the Influence (DUI).</p>\r\n                    <p>Becoming a Better Driver is easy with Metro Traffic School’s help.</p>\r\n                    <p>Metro Traffic School offers our students the ability to complete all required courses to meet their Florida Traffic School requirements. Our highly trained and experienced professionals will assist students in making informed decisions with regard to their Florida Traffic School course. Our programs are designed to fit each student’s individual needs through either a classroom or online course. Metro Traffic School is committed to delivering excellence in Traffic Safety education.</p>             \r\n                    <p>Our courses will prepare you to get behind the wheel with confidence, help you become a safer driver, avoid points or complete your requirements to get back on the road after a DUI arrest. If you received a traffic ticket for speeding or any other moving violation and you complete our 4 hour Florida Online Traffic School course you will save money on your insurance (Florida Statute 626.9541), keep points off your driving record, and maintain your safe driver status.</p><p>The principal goal and mission of Metro Traffic School is to enable students to improve driving skills, and in turn, make our streets a safer place for all drivers to share.</p>",
      site_logo: "1674627195_image_2023_01_25T06_10_10_599Z.png",
    },
  },
};
